import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createBooking } from "../api/createBooking";

export const useCreateBooking = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createBooking,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["bookings"] }),
  });
};
